var map = {
	"./json": 854,
	"./json.jsx": 854,
	"./md": 1076,
	"./md.jsx": 1076
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;



//////////////////
// WEBPACK FOOTER
// ../wrappers ^\.\/.*$
// module id = 853
// module chunks = 0